import { GridColumns } from "@mui/x-data-grid";
import React from "react";
import { useTranslation } from "react-i18next";
import { ViolationClassificationSTO } from "../../../models/violation-classification/violation-classification-sto";
import { ViolationClassificationDTO } from "../../../models/violation-classification/violation-classification-dto";
import Table from "../../../reusable-components/Table/Table";
import { ViolationClassificationApiService } from "../../../services/violation-classification/violation-classification-api.service";
import { FT_VC } from "../../../utils/constants/filter-tables-constants";
import { Grid, Typography } from "@mui/material";
import { AddEditViolationClassification } from "../../AddEditViolationClassification/AddEditViolationClassification";

const ViolationClassificationTable = () => {
  const tRP = "pages.system_settings.tables.violation_classification";
  const tRPFields = "components.add_edit_violation_classification.fields";

  const { t } = useTranslation();

  const columns: GridColumns<ViolationClassificationDTO> = [
    {
      field: "name",
      headerName: t(`common_words.name`),
      headerAlign: "center",
      disableColumnMenu: true,
      flex: 1,
    },
    {
      field: "code",
      headerName: t(`common_words.code`),
      headerAlign: "center",
      disableColumnMenu: true,
      flex: 0.5,
    },
    {
      field: "description",
      headerName: t(`common_words.description`),
      headerAlign: "center",
      disableColumnMenu: true,
      flex: 1,
    },
    {
      field: "language",
      headerName: `${t(`${tRPFields}.language`)}`,
      headerAlign: "center",
      disableColumnMenu: true,
      flex: 1,
      valueGetter: ({ row }) => row.language?.name,
    },
    {
      field: "alertLineURLs",
      headerName: `${t(`${tRPFields}.alert_line_urls`)}`,
      headerAlign: "center",
      disableColumnMenu: true,
      flex: 2,
      renderCell: ({ row }) => (
        <Grid>
          {row.alertLineURLs?.map((alertLineURLVC, idx) => (
            <Typography key={idx}>{alertLineURLVC.alertLineURL?.url}</Typography>
          ))}
        </Grid>
      ),
    },
  ];

  const DEFAULT_ITEM: ViolationClassificationSTO = {
    id: "",
    isDeleted: false,
    name: "",
    code: "",
    description: "",
    language: null,
    alertLineURLs: [],
  };

  return (
    <>
      <Table
        filter={FT_VC}
        translationRootPath={tRP}
        columns={columns}
        addEditType="custom"
        CustomAddEditComponent={AddEditViolationClassification}
        serviceApi={new ViolationClassificationApiService()}
      />
    </>
  );
};
export default ViolationClassificationTable;
